





























import { Component, Vue, Prop } from 'vue-property-decorator';

@Component
export default class ConfirmationPopup extends Vue {
  @Prop({ required: true }) show!: boolean;

  @Prop({ required: true }) title!: string;

  @Prop({ required: true }) primaryBtnText!: string;

  @Prop({ required: true }) secondaryBtnText!: string;

  onChange(show: boolean) {
    if (show) {
      this.onPrimaryBtnClick();
    } else {
      this.onSecondaryBtnClick();
    }
  }

  onPrimaryBtnClick(): void {
    this.$emit('on-primary');
  }

  onSecondaryBtnClick(): void {
    this.$emit('on-secondary');
  }
}
